import React from 'react'
import { SketchPicker } from 'react-color'

const ColorThemeTab = ({ color, handleHexColorChange, handleSaveConfig, handleResetConfig }) => {
  return (
    <div className='flex flex-col w-full space-y-3 mb-5'>
      <p className='text-[#2D3748] text-[14px] font-[400]'>Select Theme Color</p>
      <div style={{ width: '400px', height: 'auto' }}>
        <SketchPicker
          color={color}
          onChange={handleHexColorChange}
          disableAlpha={true}
        />
      </div>
      <div className='flex gap-2'>
        <button
          onClick={handleSaveConfig}
          className='bg-[#232328] mb-9 w-[85px] h-[39px] rounded-[59px] text-white text-[14px] self-start'
        >
          Save
        </button>
        <button
          onClick={handleResetConfig}
          className='bg-[#232328] mb-9 w-[85px] h-[39px] rounded-[59px] text-white text-[14px] self-start'
        >
          Reset
        </button>
      </div>
    </div>
  )
}

export default ColorThemeTab
